/* eslint-disable consistent-return */
import * as Sentry from "@sentry/browser";

import axios from "../axios";

export default async () => {
  try {
    const response = await axios.get(
      `${window.location.href.split("?")[0]}.json`
    );

    return response.data;
  } catch (err) {
    console.log(`err:${err}`);
    Sentry.captureException(err);
  }
};
